customElements.component = 'reviews-carousel';

if (!customElements.get(customElements.component)) {
  class VideoReviewsCarousel extends HTMLElement {
    constructor() {
      super();
      this.swiper = null;
      this.progressBar = this.querySelector('.reviews-carousel__desktop-progress');
      this.mobileThumbs = this.querySelector('.reviews-carousel__mobile-thumbs');
      this.prevButton = this.querySelector('.reviews-carousel__desktop-nav__prev');
      this.nextButton = this.querySelector('.reviews-carousel__desktop-nav__next');
      this.videos = this.querySelectorAll('video');
    }

    init() {
      this.initializeSwiper();
      this.updateProgressBar();
      this.addEventListeners();
    }

    initializeSwiper() {
      const swiperOptions = {
        slidesPerView: 1.15,
        spaceBetween: 16,
        grabCursor: true,
        watchSlidesProgress: true,
        pagination: {
          el: this.mobileThumbs,
          type: 'progressbar'
        },
        navigation: {
          prevEl: this.prevButton,
          nextEl: this.nextButton
        },
        breakpoints: {
          768: {
            slidesPerView: 2.2,
            spaceBetween: 20
          },
          992: {
            slidesPerView: 3.5,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3.6,
            spaceBetween: 20, 
          }
        }
      };

      this.swiper = new Swiper(this.querySelector('.swiper'), swiperOptions);
    }

    connectedCallback() {
      if (window.Swiper) {
        this.init();
      } else {
        window.addEventListener('load', () => this.init());
      }
    }

    disconnectedCallback() {
      if (this.swiper) {
        this.swiper.destroy();
      }
    }
  }

  customElements.define(customElements.component, VideoReviewsCarousel);
}